import { useTranslation } from 'react-i18next';
import CallDetailView from './components/CallDetailView';

export default function App({ callId }: { callId: number }) {
  const { t } = useTranslation();

  if (!callId) {
    return <main>{t('missingCallId')}</main>;
  }

  return <CallDetailView callId={callId} />;
}
